import builder from '../builder';
import DiscountStarPremium from '../../streamline-icons/light/discount-star-premium.svg';

export default builder('IconDiscountStarPremiumLight', DiscountStarPremium);
